import { RoleEnum } from "../enums/role";
import { STAFF_PERMISSION_ROUTES } from "../routes/permissions/staff";

export const checkPermission = (
  roleType: string,
  pathRoute: string
): boolean => {
  if (roleType === RoleEnum.MERCHANT) {
    return true;
  } else if (roleType === RoleEnum.STAFF) {
    return STAFF_PERMISSION_ROUTES.includes(pathRoute);
  } else {
    return false;
  }
};
